import { MiniNavbar } from "@/components/ui/mini-navbar";
import { Hero } from "@/components/landing/Hero";
import { Features } from "@/components/landing/Features";
import { Pricing } from "@/components/landing/Pricing";
import { Footer } from "@/components/landing/Footer";

/**
 * Landing: demo is the product (globe under demo in Hero).
 * Features = consolidated why + how (bento). Pricing below.
 */
export function Home() {
  return (
    <div className="min-h-screen bg-og-ink text-white">
      <MiniNavbar />
      <main>
        <Hero />
        <Features />
        <Pricing />
      </main>
      <Footer />
    </div>
  );
}
